const TOURNAMENT_STATUS = {
  maybego: 1,
  maybeend: 2,
};

const DEFAULT_NAMES = {
  tournament: 'Основной турнир',
  stage: 'Основной турнирный этап',
  group: 'Основная турнирная группа',
};

export default {
  TOURNAMENT_STATUS,
  DEFAULT_NAMES,
};
